import Token from './Token'
import AppStorage from './AppStorage'
import swal from 'sweetalert2'

class User {

    login(data) {
        let url = process.env.NODE_ENV == 'production' ? process.env.VUE_APP_API_URL_PROD : process.env.VUE_APP_API_URL_LOCAL
        axios.post(`${url}/api/auth/login`, data, {
          headers: {
            Authorization: `Bearer ${AppStorage.getToken()}`
        }}).then(res => {
            this.responseAfterLogin(res)
            // this.fetchVideos(url)
            // this.fetchCategories(url)
            this.getProfile(url)
            return true
        }).catch(error => {
            EventBus.$emit('failedLogin')
            console.log('error!', error)
            return true
        })
    }

    signup(data) {
      let url = process.env.NODE_ENV == 'production' ? process.env.VUE_APP_API_URL_PROD : process.env.VUE_APP_API_URL_LOCAL
      axios.post(`${url}/api/signup`, data).then(res => {
          swal('Success', 'Successful registration. <br> Please go to email box and confirm your registration.', 'success')
          return 'yes it works'
      }).catch(error => {
          EventBus.$emit('failedRegistration')
          var errorMessage = error.response.data.errors[Object.keys(error.response.data.errors)[0]]; //returns 'someVal'
          swal('Error', '<br>' + errorMessage, 'warning')
          return 'no, it does not work'
      })
    }

    responseAfterLogin(res){
        const access_token = res.data.access_token
        const user_name = res.data.user_name
        const user_id = res.data.user_id
        const role_id = res.data.role_id
        const verified = res.data.verified
        if(Token.isValid(access_token)){
          // if(verified === '1') {
          //   window.location = '#/videos/all'
          // } else {
          //   window.location = '#/login'
          // }
          AppStorage.store(user_name, user_id ,access_token, role_id)
        }
    }

    fetchVideos(url) {
      axios.get(`${url}/api/organizations`)
      .then(res => {
          console.log(res.data)
          AppStorage.storeVideos(res.data.data)
          EventBus.$emit('successfulLogin')
      })
      .catch(error => console.log(error));
    }

    fetchCategories(url) {
      axios.get(`${url}/api/categories`)
      .then(res => {
          AppStorage.storeCategories(res.data.data)
      })
      .catch(error => console.log(error));
    }

    getProfile(url) {
        axios.get(`${url}/api/users/${this.id()}`, {
          headers: {
            Authorization: `Bearer ${AppStorage.getToken()}`
        }})
        .then(res => {
            AppStorage.storeProfile(res.data.data)
        })
        .catch(error => {
            // this.errors = error.response.data
            // if(error.response.status == 401 && User.loggedIn()) {
            // this.$refs.logout.open(
            //     'Login Required',
            //     'Your token has expired. Please login again.',
            // { color: 'red' }).then((logout) => {});
            // }
        })
    }

    hasToken(){
        const storedToken = AppStorage.getToken()
        if(storedToken){
            return Token.isValid(storedToken) ? true : this.logout()
        }

        return false
    }

    loggedIn(){
        return this.hasToken()
    }

    logout(redirect){
        AppStorage.clear()
        if(redirect) {
            window.location = `/admin/${redirect}`
        } else {
            window.location = '/admin/overview'
        }

    }

    name(){
        if(this.loggedIn()){
            return AppStorage.getUserName()
        }
    }

    id(){
        if(this.loggedIn()){
            return AppStorage.getUserId()
        }
        //another way to get the user id
        // const payload = Token.payload(AppStorage.getToken())
        // return payload.sub
    }

    role() {
        if(this.loggedIn()){
            return AppStorage.getRole()
        }
    }

    own(id){
        return this.id() == id
    }

    admin(){
        return this.role() == 1
    }

    member(){
        return AppStorage.getMember() == 'true' ? true : false
    }
}

export default User = new User();
